import { render, staticRenderFns } from "./Celtic-18-19-Home.vue?vue&type=template&id=71e3d34a&"
import script from "./Celtic-18-19-Home.vue?vue&type=script&lang=js&"
export * from "./Celtic-18-19-Home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports